import {Model} from 'backbone';
import {curry} from 'lodash';

//:: TagModel -> TagModel -> Boolean
export const tagEquals = curry(
    (t1, t2) => t1.get('name') === t2.get('name') && t1.get('dimension') === t2.get('dimension'),
);

export const TagModel = Model.extend({
    idAttribute: 'uuid',
    blacklist: ['included'],
    defaults: () => ({
        included: true,
    }),
    equals(tag) {
        return tagEquals(this, tag);
    },
    /**
     * Used to determine if the model should receive an order
     *
     * @returns {boolean}
     */
    getIsOrderable() {
        return true;
    },
});

TagModel.of = (...args) => new TagModel(...args);

export default TagModel;
